import type { FileRouteTypes } from '@client/routeTree.gen';
import { useRouter } from '@tanstack/react-router';
import { useCallback } from 'react';

export function useGetRouteMatches() {
    const router = useRouter();

    // Stable across renders (the router instance is): lets callers memoise
    // derived work such as the navigation trees' access filtering.
    return useCallback((path: FileRouteTypes['to']) => router.matchRoutes(path, {}), [router]);
}
